import * as $ from 'jquery';
import * as angular from "angular";

import 'bootstrap/less/bootstrap.less';

import 'sweetalert/dist/sweetalert.css';
import 'chosen-js/chosen.css';
import 'perfect-scrollbar/dist/css/perfect-scrollbar.css';
import 'angularjs-toaster/toaster.css';
import 'angular-loading-bar/build/loading-bar.css';
import 'fullcalendar/dist/fullcalendar.css';

import './styles/animate.css';
import './styles/climacons-font.css';
import './styles/feather.css';
import './styles/panel.css';
import './styles/roboto.css';

import 'font-awesome/css/font-awesome.css';

import 'bootstrap/dist/js/bootstrap.js';
import 'angular-ui-router/release/angular-ui-router.js';

import 'perfect-scrollbar';
import 'moment';
import 'fullcalendar';
import 'angular-ui-calendar';
import 'angular-ui-bootstrap';
import 'angular-animate';
import 'datatables';
import 'angular-datatables';
import 'angularjs-toaster';
import 'angular-loading-bar';
import 'restangular';
import 'sweetalert';
import 'angular-sweetalert';
import 'chosen-js';

import './scripts/bootstrap-datatables.js';

import './app/main';




// WEBPACK FOOTER //
// ./~/@abosol/theme/src/index.ts